
import Vue from 'vue';

import '@/icons';

const requireComponent = require.context('./components/global', true, /\.js$/);
requireComponent.keys().forEach(fileName => {
  const component = requireComponent(fileName).default;
  if (component) {
    Vue.use(component);
  }
});

import FailureRetry from '@/components/global/FailureRetry';
Vue.component('ds-failure-retry', FailureRetry);

import DataEmpty from '@/components/global/DataEmpty';
Vue.component('ds-data-empty', DataEmpty);

